module.exports = __webpack_public_path__ + "media/metronic/_theme/media/demos/preview/demo16-0d42bd47d1b5400452208fddecf11618.jpg";